import { RootState } from "@/app/stores"
import { getBonuses, IBonus } from "@/shared/api/bonuses"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBonuses = createAsyncThunk<
    IBonus[],
    void,
    { state: RootState }
>('bonuses/fetchBonuses', async(_, thunkAPI) => {
    try {
        const data = await getBonuses()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})